// src/features/eVisitingCard/VisitingCard.thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import {
  fetchGroupsApi,
  fetchAllTemplatesApi,
  fetchTemplatesByGroupApi,
  fetchLanguagesApi,
  fetchLanguageDetailsApi
} from "../../api/VisitingCardApi";

// 👉 FETCH GROUPS
export const fetchGroupsThunk = createAsyncThunk(
  "eCard/fetchGroups",
  async (_, thunkAPI) => {
    try {
      const res = await fetchGroupsApi();
      return res.data.data;        // array of groups
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message);
    }
  }
);

// LOAD ALL CARDS (also loads groups inside Promotional Card)
// GET ALL CARDS (includes promotional groups)
export const fetchAllCardsThunk = createAsyncThunk(
  "eCard/fetchAllCards",
  async (_, thunkAPI) => {
    try {
      const res = await axiosInstance.get("api/e-visitingcard/card-templates");
      return res.data.data; 
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message);
    }
  }
);

// GET ONLY TEMPLATES OF SELECTED GROUP
export const fetchTemplatesByGroupThunk = createAsyncThunk(
  "eCard/fetchTemplatesByGroup",
  async (groupId, thunkAPI) => {
    try {
      const res = await axiosInstance.get(
        `api/e-visitingcard/card-templates?groupId=${groupId}`
      );

      // Extract ONLY templates of selected group (works for Promotional Card and Business Card)
      const cardWithGroups = res.data.data.find(
        (c) => c.groups?.some((g) => g._id === groupId)
      );
      const group = cardWithGroups?.groups?.find((g) => g._id === groupId);

      return group?.templates || [];
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message);
    }
  }
);

// 👉 SEND CUSTOMIZATION REQUEST – only if you need it
export const sendCustomizationRequestThunk = createAsyncThunk(
  "eCard/sendCustomization",
  async (cardId, thunkAPI) => {
    try {
      const res = await axiosInstance.post(
        "api/e-visitingcard/customize-visiting-card-request",
        { cardId }
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message);
    }
  }
);


export const fetchMyCustomRequestsThunk = createAsyncThunk(
  "eCard/fetchMyCustomRequests",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("api/e-visitingcard/get-customize-visiting-card-request");
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);


// Fetch all languages
export const fetchLanguagesThunk = createAsyncThunk(
  "eCard/fetchLanguages",
  async (_, thunkAPI) => {
    try {
      const res = await fetchLanguagesApi();
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message);
    }
  }
);

// Fetch language-based user + card labels
export const fetchLanguageDetailsThunk = createAsyncThunk(
  "eCard/fetchLanguageDetails",
  async (languageId, thunkAPI) => {
    try {
      const res = await fetchLanguageDetailsApi(languageId);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message);
    }
  }
);
